import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export function fetchEmployeesApi(params, config) {
  return axiosRequest('post', serviceUrls.EMPLOYEES_GET_EMPLOYEES, params, config);
}

export function fetchEmployeeDetailHeaderApi(contactId) {
  return axiosRequest('post', serviceUrls.EMPLOYEES_GET_EMPLOYEE_DETAIL_HEADER, { contactId });
}

export function fetchEmployeeDetailApi(contactId) {
  return axiosRequest('post', serviceUrls.EMPLOYEES_GET_EMPLOYEE_DETAIL, { contactId });
}

export function updateEmployeeDetailsApi(body = {}) {
  return axiosRequest('post', serviceUrls.EMPLOYEES_UPDATE_EMPLOYEE_DETAILS, body);
}

export function upsertEmployeesContactEmploymentHistorySalaryApi(data) {
  return axiosRequest('post', serviceUrls.EMPLOYEES_UPSERT_CONTACT_EMPLOYMENT_HISTORY_SALARY, data);
}
